// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fab-wrapper {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 10px;
}

.floating-action-button {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #0B2D71;
  color: white;
  border: none;
  box-shadow: 0 4px 14px rgba(11, 45, 113, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999;
  animation: subtle-pulse 4s ease-in-out infinite;
  overflow: visible;
}
.floating-action-button::after {
  content: "";
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border-radius: 50%;
}
.floating-action-button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}
.floating-action-button:hover {
  background: rgb(8.7379032258, 35.7459677419, 89.7620967742);
  box-shadow: 0 8px 28px rgba(11, 45, 113, 0.5), 0 4px 12px rgba(0, 0, 0, 0.3);
  transform: scale(1.08) translateY(-2px);
  animation: none;
}
.floating-action-button:hover::before {
  width: 100%;
  height: 100%;
}
.floating-action-button:active {
  transform: scale(0.96) translateY(0);
  box-shadow: 0 4px 12px rgba(11, 45, 113, 0.4), 0 2px 6px rgba(0, 0, 0, 0.2);
}
.floating-action-button i {
  line-height: 1;
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.resume-badge {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #009DD9;
  border: 2px solid white;
  z-index: 2;
  animation: badge-pulse 2s ease-in-out infinite;
}

.resume-pill {
  opacity: 0;
  transform: translateX(8px);
  pointer-events: none;
  white-space: nowrap;
  background: rgba(11, 45, 113, 0.8);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  color: white;
  font-size: 11px;
  font-weight: 400;
  padding: 6px 11px;
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(11, 45, 113, 0.28), 0 2px 6px rgba(0, 0, 0, 0.18);
  animation: resume-pill-attention 6s ease forwards;
}

.fab-wrapper:hover .resume-pill {
  opacity: 0.9;
  transform: translateX(0);
  animation: none;
}

@keyframes badge-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 157, 217, 0.5);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(0, 157, 217, 0);
  }
}
@keyframes resume-pill-attention {
  0% {
    opacity: 0;
    transform: translateX(8px);
  }
  10% {
    opacity: 0.9;
    transform: translateX(0);
  }
  75% {
    opacity: 0.9;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(8px);
  }
}
@keyframes subtle-pulse {
  0%, 100% {
    box-shadow: 0 4px 14px rgba(11, 45, 113, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(11, 45, 113, 0.3);
  }
  50% {
    box-shadow: 0 4px 14px rgba(11, 45, 113, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15), 0 0 0 8px rgba(11, 45, 113, 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .floating-action-button {
    animation: none;
    transition: none;
  }
  .floating-action-button::before {
    transition: none;
  }
  .resume-badge {
    animation: none;
  }
  .resume-pill {
    opacity: 0.9;
    transform: none;
    animation: none;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
